// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoPlayerStyles__container--3OOX4"};